var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition-group',{staticClass:"projects",attrs:{"tag":"div"}},_vm._l((_vm.projects),function(project){return _c('div',{key:project.id},[_c('project-component',{attrs:{"project":project}})],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }